<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="100%"
    height="100%"
    viewBox="0 0 14 14"
  >
    <g stroke="currentColor" stroke-width="2" clip-path="url(#a)">
      <path d="M13 3 7 9 1 3M7 0v9M1 13h12" />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M14 0v14H0V0z" /></clipPath>
    </defs>
  </svg>
</template>
